module.exports = __webpack_public_path__ + "static/media/user-checkout-light.8d1b5629.svg";